import React, { FunctionComponent, useEffect, useState } from "react";
import "./index.scss";
import { ContentPageItemCollection } from "services/entities/content";

interface VideoSizes {
  sm?: string;
  md?: string;
  lg?: string;
  xl: string;
}
type DynamicVideoProps = {
  item: VideoSizes | any;
};

export const DynamicVideo: FunctionComponent<DynamicVideoProps> = ({
  item,
}) => {
  const [videoSize, setVideoSize] = useState("xl");

  useEffect(() => {
    const updateMedia = () => {
      if (window.innerWidth < 500) {
        setVideoSize("sm");
        return;
      } else if (window.innerWidth > 500 && window.innerWidth < 800) {
        setVideoSize("md");
        return;
      } else if (window.innerWidth > 800 && window.innerWidth < 1024) {
        setVideoSize("lg");
        return;
      } else {
        setVideoSize("xl");
        return;
      }
    };
    updateMedia();
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  return (
    <>
      {(item as ContentPageItemCollection)[videoSize] ? (
        <div className="video-wrapper">
          <video
            className="background"
            src={
              (item as ContentPageItemCollection)[videoSize] &&
              (item as ContentPageItemCollection)[videoSize].toString()
            }
            muted={true}
            autoPlay={true}
            loop={true}
          />
        </div>
      ) : (
        <div className="video-wrapper">
          <video
            className="background"
            src={
              (item as ContentPageItemCollection)["xl"] &&
              (item as ContentPageItemCollection)["xl"].toString()
            }
            muted={true}
            autoPlay={true}
            loop={true}
          />
        </div>
      )}
    </>
  );
};

export default DynamicVideo;
